import { IonButton, IonButtons, IonCard, IonCardContent, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonMenuButton, IonModal, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonSearchbar, IonTitle, IonToast, isPlatform, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { addOutline, chatbubbles, checkmarkOutline, chevronForwardOutline, clipboardOutline, closeOutline, ellipsisVertical, folderOutline, notifications, refresh, timeOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { abrirBalcao, apiPedidosCaixasGET, cadastraEquipe, listaEquipePorPerfil, requestService, urlBasePedidos } from '../../../../../Utils/Services';
import GridStatus from '../../../../../components/Grid/GridStatus';
import HeaderCounterIcon from '../../../../../components/HeaderCounterIcon/HeaderCounterIcon';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { MessageContext } from '../../../../../contexts/MessageContext';
import CaixaGeralAbrir from '../CaixaGeralAbrir/CaixaGeralAbrir';
import { filtrarComandas } from '../Comandas/filtrarComandas';
import { resumoPagamentoComanda } from '../Comandas/resumoPagamentoComanda';
import Notificacoes from '../Notificacoes/Notificacoes';
import './Caixa.css';

type Props = {
  closeAction: Function;
  closeActionSimple: Function;
}

const Caixa: React.FC<Props> = (props: Props) => {
  // Navigation
  const history = useHistory();

  // Alert and Toast
  const [mostartAlerta] = useIonAlert();
  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);

  // Loading State
  const [showLoading, setShowLoading] = useState(false);

  // Contexts
  const { loja, setLoja } = useContext(MessageContext);
  const [lojas, setLojas] = useState<string>(loja);
  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const { mensagens, setMensagens } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  // State: Filtro e Listagem
  const [textoFiltro, setTextoFiltro] = useState<any>();

  const [pkCliente, setPkCliente] = useState<any>();

  // Refs
  const inputRef = useRef<any>(null);

  const [ultimoCaixa, setUltimoCaixa] = useState<any>();
  const [diasAberto, setDiasAberto] = useState(0);

  const [listaClienteComanda, setListaClienteComanda] = useState<any>([]);

  const [filter, setFilter] = useState<"todas" | "livres" | "ocupadas">("todas");

  const [showModalAbrirCaixa, setShowModalAbrirCaixa] = useState(false);

  const [showPopover, setShowPopover] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState(null);


  const openPopover = (e: any) => {
    e.persist();
    setPopoverEvent(e);
    setShowPopover(true);
  };

  const closePopover = () => {
    setShowPopover(false);
    setPopoverEvent(null);
  };

  useEffect(() => {
    if (ultimoCaixa?.dataAbertura) {
      const dataAbertura: any = new Date(ultimoCaixa.dataAbertura);
      const hoje: any = new Date();
      hoje.setHours(0, 0, 0, 0); // Zera as horas para comparar apenas o dia
      dataAbertura.setHours(0, 0, 0, 0); // Zera as horas na data de abertura também

      // Calcula a diferença em milissegundos e converte para dias
      const diffDias = Math.floor((hoje - dataAbertura) / (1000 * 60 * 60 * 24));

      setDiasAberto(diffDias);
    }
  }, [ultimoCaixa]);

  useIonViewDidEnter(() => {
    setEsconderMenu(false);
    setNomeMenu("Caixa");
    buscarComandas("balcao");
    carregarCaixas();
  })

  function carregarCaixas() {
    return requestService(
      apiPedidosCaixasGET.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasGET.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (response && response.Items && response.Items.length > 0) {
          setUltimoCaixa(response.Items[0]);
        }
      },
      (error: any) => {
        console.log(error);
      }
    )
  };

  async function unirListas(perfil: any) {
    let listaComandas = await buscarComandasDynamoDb(perfil);
    let listaComandasAbertas = await buscarComandasAbertasDynamoDb();

    // Se qualquer uma das listas for undefined, inicialize-a como uma lista vazia
    listaComandas = listaComandas || [];
    listaComandasAbertas = listaComandasAbertas || [];

    // Criando um mapa para listaComandasAbertas usando clienteid como chave
    let mapaComandasAbertas = new Map(listaComandasAbertas.map((item: any) => [item.clienteid, item]));

    // Unindo as listas
    let listaUnida = listaComandas.map((comanda: any) => {
      let comandaAberta: any = mapaComandasAbertas.get(comanda.pk);

      return {
        ...comanda, // Mapeia as propriedades de comanda
        ...comandaAberta // Mapeia as propriedades de comandaAberta se houver correspondência
      };
    });

    // console.log(listaUnida);

    return listaUnida;
  }

  const buscarComandas = async (perfil: any) => {
    try {
      setShowLoading(true);
      let listaComandas = await unirListas(perfil);

      setListaClienteComanda([]);
      if (Array.isArray(listaComandas) && listaComandas.length > 0) {
        let lista = (listaComandas.sort((a: any, b: any) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : -1))

        // console.log("lista", lista);
        setListaClienteComanda(lista);

      }
    } catch (error: any) {
      console.error("Ocorreu um problema inesperado. Por favor, tente novamente mais tarde. Detalhes do erro: ", error);
      setTextToast(error);
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }

  }

  const buscarComandasDynamoDb = async (perfil: any) => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let montarUrl = listaEquipePorPerfil.url.replace("{loja}", loja.replaceAll(/#/g, "%23")).concat("?status=ativo&lojas=" + Buffer.from(loja).toString('base64'));

    const resp = await fetch(montarUrl.replace("{perfil}", perfil),
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let comandas = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (comandas.Items) {
        if (comandas.Items.length > 0) {
          return comandas.Items;
        }
        else {
          const objectRequest =
          {
            "cpf": "",
            "dataAniversario": "",
            "email": "",
            "empresaMarca": "",
            "endereco": "",
            "interno": true,
            "lojas": JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
              return lojas.includes(value.empresaLojaId);
            }),
            "nome": "Balcão",
            "perfil": "balcao",
            "pk": "",
            "statusUsuario": "ativo",
            "telefone": "55"
          };

          requestService(cadastraEquipe.url, {
            method: cadastraEquipe.method,
            headers: [["token", localStorage.getItem("token") || ""]],
            credentials: 'include',
            body: JSON.stringify(objectRequest)
          },
            history,
            (response: any) => {
              if (response && response.usuario) {

                buscarComandas("balcao");
              }
            },
            (error: any) => {
              console.log("error", error);
            });
        }
      }
    }
  }

  const buscarComandasAbertasDynamoDb = async () => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let urlFinal = urlBasePedidos.url + "/balcao/listaabertas?filtro=caixa".concat("&lojas=" + Buffer.from(loja).toString('base64'));

    const resp: Response = await fetch(urlFinal,
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let comandas = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (comandas) {
        return comandas;
      }
    }
  }

  function continuarMesa(cliente: any, novoNome: any) {

    setShowLoading(true);

    let objRequest = {
      tipo: "caixa",
      novoNome: novoNome,
      clienteid: cliente.replaceAll(/#/g, '%23'),
    };

    return requestService(abrirBalcao.url.replaceAll("{id}", cliente.replaceAll(/#/g, '%23')).concat("?lojas=" + Buffer.from(loja).toString('base64')), {
      method: abrirBalcao.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {
        if (response && response.message) {
          history.push("caixa/produtos", { id: response.message.pk.replaceAll(/#/g, '%23') });
        }

      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message);
        setShowToast(true);
      }).finally(() => {
        setShowLoading(false);
      })


  }

  function tempoAndamento(dataCadastro: any) {
    if (!dataCadastro) {
      // Se não houver dataCadastro, retorna vazio
      return "";
    }

    // Convertendo a dataCadastro para um objeto de data
    const dataCadastrada = new Date(dataCadastro);
    const agora = new Date();

    // Calcula a diferença em milissegundos
    const diferencaMs = agora.getTime() - dataCadastrada.getTime();

    // Converte para unidades de tempo
    const minutos = Math.floor(diferencaMs / 1000 / 60) % 60; // Restante dos minutos
    const horas = Math.floor(diferencaMs / 1000 / 60 / 60) % 24; // Restante das horas
    const dias = Math.floor(diferencaMs / 1000 / 60 / 60 / 24); // Total de dias

    // Formatação da saída
    let resultado = "";

    if (dias > 0) {
      resultado += `${dias} ${dias === 1 ? "dia" : "dias"}`;
      return resultado;
    }
    if (horas > 0) {
      resultado += `${dias > 0 ? ", " : ""}${horas} ${horas === 1 ? "hora" : "horas"}`;
    }
    if (minutos > 0) {
      resultado += `${dias > 0 || horas > 0 ? " e " : ""}${minutos} ${minutos === 1 ? "minuto" : "minutos"}`;
    }

    return resultado || "Agora mesmo";
  }

  function readListaComandas() {

    const listaFiltrada = filtrarComandas(listaClienteComanda, textoFiltro, filter);

    return listaFiltrada.map((value: any, index: any) => {
      const resumo = resumoPagamentoComanda(value);
      return (
        <React.Fragment key={value.pk || value.id || index}>
          <div className="caixa-grid-cell">
            <IonCard className={`caixa-card ${value.sk ? (resumo.aFechar ? 'caixa-card--a-fechar' : 'caixa-card--aberta') : 'caixa-card--livre'}`} disabled={!(ultimoCaixa && ultimoCaixa.status == "aberto")}
              // color={(value.clienteid ?? value.pk) == pkCliente ? "danger" : 'light'}
              button
              onClick={() => {

                console.log("value.clienteid", value.clienteid);
                console.log("value.pk", value.pk);
                setPkCliente(value.clienteid || value.pk);
                if (value.clienteid) {
                  history.push("caixa/produtos", { id: value.pk.replaceAll(/#/g, '%23') });
                }
                else {

                  if (acessos?.balcao == 'edicao') {
                    mostartAlerta({
                      backdropDismiss: false,
                      header: value.nome,
                      message: `
                        <div>
                          <p style="margin-bottom: 16px;">Nome do cliente:</p>
                          <ion-item lines="none">
                            <ion-input id="editableTitle"></ion-input>
                          </ion-item>
                        </div>
                      `,
                      buttons: [
                        {
                          text: 'Cancelar',
                          role: 'cancel',
                          handler: () => {
                            setPkCliente("");
                          },
                        },
                        {
                          text: 'Abrir',
                          handler: async () => {
                            const inputElement: any = document.querySelector('#editableTitle');
                            const editedTitle = inputElement?.value || value.nome;
                            console.log('Título editado:', editedTitle);
                            continuarMesa(value.pk, editedTitle);
                          },
                        },
                      ],
                      onDidDismiss: () => {
                        console.log('did dismiss');
                      },
                    });


                  }
                  else {
                    setTextToast("Você não tem permissão para acessar esta funcionalidade.");
                    setShowToast(true);
                  }
                }
              }}
            >

              <IonCardContent>
                <div className="caixa-card-top">
                  <h2 className="caixa-card-name">{value.clienteNome || value.nome}</h2>
                  <GridStatus tone={value.sk ? (resumo.aFechar ? 'warning' : 'success') : 'neutral'} icon={value.sk && !resumo.aFechar ? clipboardOutline : checkmarkOutline}>
                    {value.sk ? (resumo.aFechar ? 'A fechar' : 'Aberta') : 'Livre'}
                  </GridStatus>
                  <IonIcon className="caixa-card-arrow" icon={chevronForwardOutline} aria-hidden="true" />
                </div>
                {value.sk ? (
                  <>
                    <p className="caixa-card-total"><span>Total</span><strong>{value.valorTotal ? `R$ ${value.valorTotal}` : 'R$ 0,00'}</strong></p>
                    <div className="caixa-card-amounts">
                      {resumo.aFechar ? (
                        <p className="caixa-paid">Pago integralmente</p>
                      ) : (
                        <>
                          {resumo.totalPago > 0 && (
                            <>
                              <p className="caixa-paid">Pago: R$ {resumo.pagoFormatado}</p>
                              <span className="caixa-amount-divider" aria-hidden="true">|</span>
                            </>
                          )}
                          <p className="caixa-unpaid">Em aberto: R$ {resumo.restanteFormatado}</p>
                        </>
                      )}
                    </div>
                    {value.dataCadastro && (
                      <div className="caixa-elapsed">
                        <IonIcon icon={timeOutline} aria-hidden="true" /> Aberta há {tempoAndamento(value.dataCadastro)}
                      </div>
                    )}
                  </>
                ) : (
                  <span className="caixa-start"><IonIcon icon={addOutline} aria-hidden="true" />Abrir atendimento</span>
                )}
              </IonCardContent>
            </IonCard>
          </div>
        </React.Fragment>

      );
    });
  }

  //   setShowLoading(true);
  //   //setBotaoAtivo(false);

  //   // const found = listaCliente.find((obj: any) => {
  //   //   return obj.pk === cliente;
  //   // });

  //   // console.log("found", found);

  //   let objRequest = {
  //     clienteid: pkCliente.replaceAll(/#/g, '%23'),
  //     formaPagamento: formaPagamento,
  //     desconto: desconto,
  //     taxaServico: taxaServico
  //   };

  //   return requestService(encerrarComanda.url.replaceAll("{id}", pkCliente.replaceAll(/#/g, '%23')), {
  //     method: encerrarComanda.method,
  //     headers: [
  //       ["token", window.localStorage.getItem("token")]
  //     ],
  //     body: JSON.stringify(objRequest),
  //     credentials: 'include'
  //   },
  //     history,
  //     (response: any) => {
  //       if (response) {
  //         console.log("response", response);
  //         setRecarregarProjeto(true);
  //         setListaItemProdutos([]);
  //         // history.goBack();
  //       }
  //       //setBotaoAtivo(true);
  //       setShowLoading(false);
  //     },
  //     (error: any) => {
  //       console.log(error);
  //       //setBotaoAtivo(true);
  //       setShowLoading(false);
  //       setTextToast(error.message);
  //       setShowToast(true);
  //     })


  // }


  // const handleEtapaChange = (value: any) => {
  //   setSelectedButton(value);
  //   buscarComandas(value);
  //   window.localStorage.setItem("opcaoCriarPedido", value);

  // };

  function doRefresh(event: any) {
    buscarComandas("balcao");
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  async function closeModalNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalSimpleNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalAbrirCaixa() {
    setShowModalAbrirCaixa(false);
  }

  async function closeModalAbrirCaixaSuccess() {
    carregarCaixas();
    setShowModalAbrirCaixa(false);
  }

  return (
    <IonPage className="caixa-page">

      <IonHeader className="ion-no-border">
        <IonToolbar className="caixa-toolbar">
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>Balcão</IonTitle>


          <IonButtons slot="end">
            <IonButton className="xeguei-header-counter-button" aria-label="Notificações" onClick={() => { setShowNotificacoes(true); }}>
              <HeaderCounterIcon icon={notifications} count={notificacoes?.length} />
            </IonButton>
          </IonButtons>

          <IonButtons slot="end" hidden={acessos?.chat != 'leitura' && acessos?.chat != 'edicao'}>
            <IonButton className="xeguei-header-counter-button" aria-label="Conversas" onClick={() => { history.push("./chat"); }}>
              <HeaderCounterIcon icon={chatbubbles} count={mensagens?.length} />
            </IonButton>
          </IonButtons>

          <IonButtons slot="end">
            <IonButton aria-label="Mais opções" onClick={openPopover}>
              <IonIcon slot="icon-only" icon={ellipsisVertical} />
            </IonButton>
          </IonButtons>

          <IonPopover className="caixa-options"
            isOpen={showPopover}
            event={popoverEvent}
            onDidDismiss={closePopover}
          >
            <IonList>


              <IonItem lines="none" button hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao' && !(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas")}
                onClick={() => {
                  history.push("caixa/caixahistorico"); closePopover();
                }}>
                <IonIcon icon={folderOutline} slot="start" />
                <IonLabel>Histórico</IonLabel>
              </IonItem>

              <IonItem lines="none" button onClick={closePopover}>
                <IonIcon icon={closeOutline} slot="start" />
                <IonLabel>Cancelar</IonLabel>
              </IonItem>
            </IonList>
          </IonPopover>

        </IonToolbar>

      </IonHeader>



      <IonContent className="caixa-content">

        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>



        <main className="caixa-container">
          <div className="caixa-filter-bar">
            <div className="caixa-search-panel">

              <IonSearchbar className="caixa-search" aria-label="Buscar balcão ou cliente"
                ref={inputRef}
                value={textoFiltro}
                onIonChange={(e) => {
                  setTextoFiltro(e.detail.value);
                }}
                enterkeyhint="search"
                placeholder="Buscar balcão ou cliente"
              />
            </div>
            <div className="caixa-filters" role="group" aria-label="Filtrar por status">
              <button type="button" aria-pressed={filter === 'todas'} onClick={() => setFilter('todas')}>
                <IonIcon icon={clipboardOutline} aria-hidden="true" />Todas
              </button>
              <button type="button" aria-pressed={filter === 'livres'} onClick={() => setFilter('livres')}>
                <IonIcon icon={checkmarkOutline} aria-hidden="true" />Livres
              </button>
              <button type="button" aria-pressed={filter === 'ocupadas'} onClick={() => setFilter('ocupadas')}>
                <IonIcon icon={timeOutline} aria-hidden="true" />Abertas
              </button>
            </div>
            <div className="caixa-refresh-control" hidden={isPlatform("android") || isPlatform("ios")}>
              <IonButton className="caixa-refresh" aria-label="Atualizar" title="Atualizar" fill="outline" onClick={() => { buscarComandas("balcao"); }} >
                <IonIcon slot="start" icon={refresh} aria-hidden="true" /><span>Atualizar</span>
              </IonButton>
            </div>
          </div>
          <div className="caixa-grid">{readListaComandas()}</div>
          <section className="caixa-empty" hidden={showLoading} role="status">
            <IonIcon icon={clipboardOutline} aria-hidden="true" />
            <h2>Nenhum resultado</h2>
            <p>{textoFiltro || filter !== 'todas' ? 'Tente outro nome ou selecione um status diferente.' : 'Os balcões cadastrados aparecerão aqui.'}</p>
          </section>
        </main>


        <IonModal isOpen={showNotificacoes} onDidDismiss={() => { setShowNotificacoes(false); }}>
          <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes}></Notificacoes>
        </IonModal>


        <IonModal isOpen={showModalAbrirCaixa} onDidDismiss={() => { setShowModalAbrirCaixa(false); }}>
          <CaixaGeralAbrir closeAction={closeModalAbrirCaixaSuccess} closeActionSimple={closeModalAbrirCaixa}></CaixaGeralAbrir>
        </IonModal>

      </IonContent>

      <IonFooter className="caixa-footer">
        <IonToolbar className="caixa-cash-toolbar" hidden={ultimoCaixa?.status === "aberto" || false}>
          <div className="caixa-cash-notice">

            <div className="caixa-cash-description">
              <IonLabel>
                <>Para começar efetuar vendas é preciso <strong>abrir o caixa</strong></>
              </IonLabel>
            </div>
            <div className="caixa-cash-action">
              <IonButton
                disabled={acessos?.caixa != 'edicao'} color="success"
                className="caixa-open-cash" onClick={() => {
                  setShowModalAbrirCaixa(true);
                }}>
                Abrir Caixa
              </IonButton>
            </div>
          </div>
        </IonToolbar>


        <IonToolbar className="caixa-cash-toolbar" hidden={!(ultimoCaixa && ultimoCaixa.status === "aberto" && diasAberto > 0)}>
          <div className="caixa-cash-notice">
            <div className="caixa-cash-description">
              <IonLabel>
                <>Seu caixa está <strong>{diasAberto} dia(s) aberto</strong></>
              </IonLabel>
            </div>
            <div className="caixa-cash-action">
              <IonButton disabled={acessos?.caixa != 'edicao'} className="caixa-close-cash" color="danger" onClick={() => history.push("./caixageral")}>
                Fechar Caixa
              </IonButton>
            </div>
          </div>
        </IonToolbar>

      </IonFooter>

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </IonPage >
  );
};

export default Caixa;